import React, { useContext, useRef } from "react";
import { CurrentChatContext } from "@/components/context";
import { MainDefault } from "@/components/mainchat/maindefault";
import { CurrentChat } from "@/components/mainchat/currentchat";
import { ChatForm } from "@/components/chatform/chatform";
import { ChatCircleText, List } from "@phosphor-icons/react";
import { SidebarProps } from "@/lib/types";
import { AssistantAvatar } from "@/components/ui/assistantavatar";
import { AuthenticatedTemplate } from "@azure/msal-react";

export const MainChat = ({ sidebar }: SidebarProps) => {
    const { currentChat, updateCurrentChat } = useContext(CurrentChatContext);
    const BottomOfPageRef = useRef<HTMLDivElement | null>(null);

    return (
        <div className={`flex-1 h-svh flex-col ${sidebar.sidebarOpen ? "hidden" : "flex"} lg:flex`}>
            <div className={"flex-1 overflow-y-auto"}>
                <div className={"lg:hidden pt-4 px-2 flex flex-row justify-between items-start"}>
                    <div data-testid="sidebar" onClick={() => sidebar.setSidebarOpen(true)}>
                        <List size={24} className={"text-zinc-700"} />
                    </div>
                    <div>
                        <AssistantAvatar size={24} animate={false} />
                    </div>
                    <div onClick={() => updateCurrentChat(undefined)}>
                        <ChatCircleText size={24} className={"text-zinc-700"} />
                    </div>
                </div>
                {currentChat === undefined ? (
                    <MainDefault />
                ) : (
                    <CurrentChat bottomOfPage={BottomOfPageRef.current} />
                )}
                <div ref={BottomOfPageRef} className={"bottom-of-page"} />
            </div>
            <div className={"flex-none"}>
                <AuthenticatedTemplate>
                    <ChatForm />
                </AuthenticatedTemplate>
            </div>
        </div>
    );
};
